import { registerSW } from 'virtual:pwa-register';

/**
 * Registrasi service worker (T-P7-01/02).
 *
 * Pola *prompt*, bukan auto-reload: pembaruan yang memuat ulang halaman sendiri
 * akan menghapus wizard kunjungan yang sedang diisi — kerugian paling mahal yang
 * bisa dialami collector, dan justru terjadi saat aplikasi sedang dipakai.
 */

export type UpdateState =
  | { status: 'idle' }
  | { status: 'offline-ready' }
  | { status: 'update-available'; apply: () => Promise<void> };

let state: UpdateState = { status: 'idle' };
const listeners = new Set<() => void>();

export function getUpdateState(): UpdateState {
  return state;
}

export function subscribeUpdate(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function set(next: UpdateState): void {
  state = next;
  for (const listener of listeners) listener();
}

export function registerServiceWorker(): void {
  if (import.meta.env.DEV && !import.meta.env.VITE_ENABLE_SW_IN_DEV) return;

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      set({
        status: 'update-available',
        apply: async () => {
          set({ status: 'idle' });
          // `reloadPage: true` — pemuatan ulang terjadi setelah pengguna menekan
          // tombol, jadi tidak ada pekerjaan yang hilang tanpa persetujuannya.
          await updateSW(true);
        },
      });
    },
    onOfflineReady() {
      set({ status: 'offline-ready' });
    },
  });
}

/** Versi & waktu build disuntikkan Vite; dipakai halaman Akun (T-P7-02). */
export const APP_VERSION = __APP_VERSION__;
export const APP_BUILT_AT = __APP_BUILT_AT__;
